
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getSelectedDateRange, getConverionType} from 'redux/modules/currentUser/selectors'
import {
  setActiveFilter,
  setSessionFilter,
  setSessionsOnlyFilter,
  resetActiveFilters,
  resetFiltersAndStats,
  fetchData
} from 'redux/modules/aggr/actions'
import {
  getAggrChannel,
  getAggrStats,
  getFiltersData,
  getOrdersPageCurrent,
  getOrdersPageCount,
  getSelectedGroups
} from 'redux/modules/aggr/selectors'
import {CSSTransitionGroup} from 'react-transition-group'
import AggChannelsList from './AggChannelsList'
import AggrFilter from './AggrFilter'
import Icon from 'components/Icon'
import {Table, Column, Cell} from 'components/Table'
import Link from 'components/Link'
import Limit from 'containers/Limit'
import UpgradePanel from 'components/UpgradePanel'
import propsChanged from 'utils/propsChanged'
import distanceInWords from 'date-fns/distance_in_words'
import addMilliseconds from 'date-fns/add_milliseconds'
import classnames from 'classnames'
import ChannelIcon from 'components/ChannelIcon'
import take from 'lodash/take'
import isEqual from 'lodash/isEqual'
import unionWith from 'lodash/unionWith'
import AggrChart from './AggrChart'
import AggrSingleTouch from './AggrSingleTouch'

export class AggreatedAttributionView extends React.Component {
  static propTypes = {
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    aggrChannel: PropTypes.array,
    aggrStats: PropTypes.object,
    ordersMaxPage: PropTypes.number,
    ordersCurrentPage: PropTypes.number,
    fetchData: PropTypes.func,
    isOrdersFetching: PropTypes.bool,
    selectedGroups: PropTypes.object,
    filters: PropTypes.object,
    sessions: PropTypes.object,
    filtersData: PropTypes.object,
    setActiveFilter: PropTypes.func,
    setSessionFilter: PropTypes.func,
    sessionsOnly: PropTypes.bool,
    setSessionsOnlyFilter: PropTypes.func,
    resetActiveFilters: PropTypes.func,
    resetFiltersAndStats: PropTypes.func,
    isOrdersFiltered: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object,
    currency: PropTypes.string,
    timezone: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      statsOpened: true
    }
  }

  componentDidMount() {
    const {currency, timezone} = this.context
    const {fetchData, startDate, endDate, filters, sessions} = this.props
    fetchData(0, startDate, endDate, currency, timezone, filters, sessions)
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {fetchData} = this.props
    const {startDate, endDate, filters, sessions, sessionsOnly} = nextProps
    const {currency, timezone} = nextContext

    if (
      propsChanged(this.props, nextProps, [
        'startDate',
        'endDate',
        'filters',
        'sessions',
        'conversionType',
        'sessionsOnly'
      ])
    ) {
      fetchData(0, startDate, endDate, currency, timezone, filters, sessions, sessionsOnly)
    }
  }

  render() {
    const {
      aggrStats,
      aggrChannel,
      isOrdersFetching,
      ordersCurrentPage,
      ordersMaxPage,
      selectedGroups,
      filtersData,
      filters,
      sessions,
      sessionsOnly,
      resetActiveFilters,
      countries,
    } = this.props

    const {permissions} = this.context

    const featureActive = permissions.read.includes('@features/orderExplorer')
    const featureConversionsStatistic = true

    return (
      <div className='aggrs-filter'>
        <Limit
          limitKey='orderExplorer'
          message={
            <UpgradePanel>
              <p>
                Sorry but our awesome filtering options are only available on a
                paid plan. Learn more about them{' '}
                <Link
                  to='/path/to/ordersExplorer'
                  className='aggrs-filter_upgrade-link'
                >
                  here
                </Link>
                .
              </p>
            </UpgradePanel>
          }
          bigIcon
        >
          <AggrFilter
            disabled={!featureActive}
            filters={filtersData}
            countries={countries}
            touchpoints={sessions}
            onFilterChange={this.onFilterChange}
            sessionsOnly={sessionsOnly}
            onSessionsOnlyChange={this.onSessionsOnlyChange}
            onFilterReset={resetActiveFilters}
            onTouchpointChange={this.onTouchpointChange}
          />
        </Limit>
        <div className='aggr-filter_filters'>
          {this.renderStats(!featureConversionsStatistic)}
          {this.renderJourney(!featureConversionsStatistic)}
          {this.renderCircle()}
        </div>
        <AggChannelsList
          aggrStats={aggrStats}
          data={aggrChannel}
          currentPage={ordersCurrentPage}
          maxPage={ordersMaxPage}
          onPageChange={this.onPageChange}
          loading={isOrdersFetching}
          selectedGroups={selectedGroups}
          filters={filters}
        />
        <AggrChart />
      </div>
    )
  }

  renderJourney(disabled) {
    const {sessions} = this.props
    const classNames = classnames('aggrs-journey', {
      'is-disabled': disabled
    })
    if (!sessions) return

    const touchpointsSections = [
      {
        key: 'first',
        title: 'First Touch',
        channel: sessions.first ?? null,
        value: sessions?.firstPercent
      },
      {
        key: 'includes',
        title: 'Includes In',
        channel: sessions.includes ?? null,
        value: sessions?.secondPercent
      },
      {
        key: 'last',
        title: 'Last Touch',
        channel: sessions.last ?? null,
        value: sessions?.lastPercent
      }
    ]
    return (
      <div className={classNames}>
        <CSSTransitionGroup
          component='div'
          className='aggrs-journey_animated'
          transitionName='stats'
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          <div className='aggrs-journey_header'>
            {touchpointsSections.map((item, key) => {
              return (
                <div
                  key={key + '_header'}
                  className='aggrs-journey_header_title'
                >
                  {item.title}
                </div>
              )
            })}
          </div>
          <div className='aggrs-journey_content'>
            {touchpointsSections.map((item, key) => {
              return (
                <div key={key + '_content'} className='aggrs-journey_sequence'>
                  <div className='aggrs-journey_sequence_item'>
                    {key === 0 && this.renderSelectedChannels(item.channel)}
                  </div>
                  <div className='aggrs-journey_sequence_item'>
                    {key === 1 && this.renderSelectedChannels(item.channel)}
                  </div>
                  <div className='aggrs-journey_sequence_item'>
                    {key === 2 && this.renderSelectedChannels(item.channel)}
                  </div>
                </div>
              )
            })}
          </div>
          <div className='aggrs-journey_content'>
            {touchpointsSections.map((item, key) => {
              return (
                <div key={key + '_value'} className='aggrs-journey_value'>
                  <span className='aggrs-journey_value_main'>
                    {item.value}%
                  </span>
                  <span className='aggrs-journey_value_text'>of all</span>
                </div>
              )
            })}
          </div>
        </CSSTransitionGroup>
      </div>
    )
  }

  renderSelectedChannels(selected) {
    if (!selected || selected.length === 0) {
      return
    }

    const length = selected.length

    if (length === 1) return this.renderOneIcon(selected)
    if (length > 1 && length <= 4) return this.renderBigIcons(selected)
    if (length > 4 && length <= 9) return this.renderSmallIcons(null, selected)

    return this.renderSmallIcons(true, selected)
  }

  renderOneIcon(selected) {
    const item = selected[0]
    const {channelGroup, channel} = item

    if (channelGroup && channel) {
      return (
        <ChannelIcon
          className='channel-group-selector_one_channel'
          name={channel}
          group={channelGroup}
          size='12px'
          active
        />
      )
    } else {
      const classNames = classnames('channel-group-selector_one_group', {
        'channel-group-selector_item': true,
        [`is-${channelGroup}`]: true
      })
      return <div className={classNames} />
    }
  }

  renderBigIcons(selected) {
    return selected.map((item, index) => {
      const {channelGroup, channel} = item
      if (channelGroup && channel) {
        return (
          <ChannelIcon
            className='channel-group-selector_big_channel tiny'
            name={channel}
            group={channelGroup}
            size='4px'
            active
            key={index}
          />
        )
      } else {
        const classNames = classnames(
          'channel-group-selector_big_group',
          {
            'channel-group-selector_item': true,
            [`is-${channelGroup}`]: true
          },
          'tiny'
        )
        return <div className={classNames} key={index} />
      }
    })
  }

  renderSmallIcons(isTiny, selected) {
    return take(selected, 16).map((item, index) => {
      const {channelGroup} = item
      const mainClass = isTiny
        ? 'channel-group-selector_tiny'
        : 'channel-group-selector_small'
      const classNames = classnames(
        mainClass,
        {
          'channel-group-selector_item': true,
          [`is-${channelGroup}`]: true
        },
        'tiny'
      )
      return <div className={classNames} key={index} />
    })
  }
  renderCircle() {
    const {sessions} = this.props
    const single = unionWith(
      sessions.first,
      sessions.includes,
      sessions.last,
      isEqual
    )

    return (
      <AggrSingleTouch
        width={210}
        height={110}
        value={sessions.singlePercent}
        single={single}
      />
    )
  }
  renderStats(disabled) {
    const {statsOpened} = this.state
    const classNames = classnames('orders-stats', {
      'is-disabled': disabled
    })

    return (
      <div className={classNames}>
        <div className='orders-stats_header'>
          <div className='orders-stats_header_title'>
            Customer Journey Statistics
          </div>
          <div
            className='orders-stats_header_icon'
            onClick={this.onToggleStatsTable}
          >
            <Icon name={statsOpened ? 'fold' : 'expand'} size='14px' />
          </div>
        </div>
        <CSSTransitionGroup
          component='div'
          className='orders-stats_animated'
          transitionName='stats'
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {this.renderStatsTable(disabled)}
        </CSSTransitionGroup>
      </div>
    )
  }

  renderStatsTable(disabled) {
    const {aggrStats, isOrdersFiltered, isOrdersFetching} = this.props
    const {statsOpened} = this.state

    if (!statsOpened) return null
    const classNames = classnames('orders-stats_table', {
      'is-filtered': isOrdersFiltered
    })
    const data = [
      {title: 'Total', count: aggrStats?.total},
      {title: 'Filtered', count: aggrStats?.filtered}
    ]
    return (
      <Table
        className={classNames}
        data={data}
        empty='No statistics for chosen date period.'
        loading={isOrdersFetching}
        loadingRows={2}
        hover
      >
        <Column
          cell={statRow => {
            const {title} = statRow
            return <Cell>{title}</Cell>
          }}
          width='90px'
        />
        <Column
          header={<Cell align='right'>Conversions</Cell>}
          cell={statRow =>
            this.renderStatsTableRow(statRow.count, 'number', disabled)
          }
        />
      </Table>
    )
  }

  renderStatsTableRow(value, format, disabled) {
    if (disabled) {
      return <Cell align='right'>-</Cell>
    }

    return (
      <Cell align='right' format={format}>
        {value}
      </Cell>
    )
  }

  renderAvgTimeToBuy(disabled, statRow) {
    const {avgTimeToBuy} = statRow
    const now = new Date()
    const newDate = addMilliseconds(now, avgTimeToBuy)

    if (disabled) {
      return <Cell align='right'>-</Cell>
    }

    return (
      <Cell align='right'>
        {distanceInWords(newDate, now, {includeSeconds: true})}
      </Cell>
    )
  }

  onToggleStatsTable = () => {
    const {statsOpened} = this.state
    this.setState({
      statsOpened: !statsOpened
    })
  }

  onPageChange = page => {
    const {currency, timezone} = this.context
    const {startDate, endDate, fetchData, filters, sessions, sessionsOnly} = this.props
   
    fetchData(page, startDate, endDate, currency, timezone, filters, sessions, sessionsOnly)
  }

  onFilterChange = (type, value) => {
    const {setActiveFilter} = this.props

    setActiveFilter && setActiveFilter(type, value)
  }

  onSessionsOnlyChange = value => {
    const {setSessionsOnlyFilter} = this.props
    if (!setSessionsOnlyFilter) return null

    setSessionsOnlyFilter(value)
  }

  onTouchpointChange = (type, value, channelTypes) => {
    const {setSessionFilter} = this.props
    if (!setSessionFilter) return null

    if (type === 'first' || type === 'last') {
      value = value[0] ? [value[0]] : []
    }

    setSessionFilter(type, value, channelTypes)
  }
}

const mapStateToProps = state => {
  const {startDate, endDate} = getSelectedDateRange(state)
  const aggrStats = getAggrStats(state)
  const conversionType = getConverionType(state)
  const isOrdersFiltered = aggrStats && aggrStats.length === 2

  return {
    startDate,
    endDate,
    conversionType,
    aggrChannel: getAggrChannel(state, startDate, endDate),
    aggrStats,
    filtersData: getFiltersData(state),
    filters: state.aggr.filters,
    sessions: state.aggr.sessions,
    sessionsOnly: state.aggr.sessionsOnly,
    isOrdersFiltered,
    isOrdersFetching: state.aggr.listFetching,
    isOrdersStatsFetching: state.aggr.globalStatsFetching,
    ordersCurrentPage: getOrdersPageCurrent(state),
    ordersMaxPage: getOrdersPageCount(state, startDate, endDate),
    selectedGroups: getSelectedGroups(state),
    countries: state.aggr.countries
  }
}

const mapDispatchToProps = {
  setActiveFilter,
  setSessionFilter,
  setSessionsOnlyFilter,
  resetActiveFilters,
  resetFiltersAndStats,
  fetchData
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AggreatedAttributionView)



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/index.js